export const SESSION_PARAMS = {
    initialMinute: 15, // minuty trwania sesji
    initialSeconds: 59, // sekundy trwania sesji
    warningMinutes: 2, // minuty do podświetlenia timera na wyraźniejszy (żółty) kolor
    infoMinutes : 10 // minuty do podświetlenia timera na wyraźniejszy (niebieski) kolor
}